import ReactCountryFlag from 'react-country-flag';

export type FlagProps = {
  countryCode: CountryCode | Lowercase<CountryCode>;
  svg?: boolean;
  cdnUrl?: string;
  cdnSuffix?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  displayName?: string;
  prefix?: number;
};

export const Flag = ({
  countryCode,
  ...rest
}: React.PropsWithChildren<FlagProps>) => (
  <ReactCountryFlag
    style={{ width: 28, height: 20, borderRadius: 4 }}
    svg
    countryCode={countryCode.toUpperCase() as CountryCode}
    {...rest}
  />
);

export default Flag;
